(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aogeo-semiconductor-journey"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => document.querySelectorAll('[data-design-version="20261013"]').forEach(root => {
      if (root.dataset.srReady) return;
      root.dataset.srReady = 'true';
      const nav = root.querySelector('.sr-nav');
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const measure = () => root.style.setProperty('--sr-nav-measured', `${Math.ceil(nav.getBoundingClientRect().height)}px`);
      new ResizeObserver(measure).observe(nav);
      measure();
      const targets = links.map(link => document.getElementById(link.hash.slice(1))).filter(Boolean);
      const update = () => {
        const threshold = nav.getBoundingClientRect().bottom + 60;
        let active = targets[0];
        for (const target of targets) if (target.getBoundingClientRect().top <= threshold) active = target;
        links.forEach(link => {
          if (active && link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };
      let scheduled = false;
      const onScroll = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { update(); scheduled = false; }); } };
      document.addEventListener('scroll', onScroll, { passive:true, capture:true });
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        for (let ancestor = target.parentElement; ancestor && ancestor !== root; ancestor = ancestor.parentElement) if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        requestAnimationFrame(update);
      });
      update();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search-empty-state"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target.closest('.aogeo-search-modal-v43 form[action*="/search"]');
    if (!form) return;
    const input = form.querySelector('input[name="q"]');
    if (input?.value.trim()) return;
    event.preventDefault();
    input?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
